import React from 'react'
import HomeIcon from '@mui/icons-material/Home'
import BreadcrumbSeparator from './BreadcrumbSeparator'
import BreadcrumbItem from './BreadcrumbItem'

const MAX_DEPTH = 5

export type BreadCrumbItem = Readonly<{
	label: string
	value: string
	onClick?: () => void
	icon?: React.ReactNode
}>

export type BreadcrumbProps = Readonly<{
	items: BreadCrumbItem[]
	separator?: string
}>

export default function Breadcrumbs({
	items,
	separator = '>',
}: BreadcrumbProps) {
	if (!items[0]) throw new Error('Items should not be empty')
	const data = (function getItems() {
		const crumbs = [items[0]]
		if (items.length > MAX_DEPTH)
			crumbs.push({ value: '...', label: '...' })
		let tooltip = ''
		for (let i = items.length - 1; i >= 0; i -= 1) {
			const middle = ` ${separator} `
			tooltip = `${items[i].label}${tooltip ? middle : ''}${tooltip}`
			if (items.length - i < MAX_DEPTH) crumbs[i] = items[i]
		}

		return {
			crumbs,
			tooltip,
		}
	})()

	const crumbs = data.crumbs.filter((c) => !!c)

	return (
		<div
			id="breadcrumbs"
			className="flex flex-row items-center gap-2"
		>
			{crumbs.map((c, index) => (
				<React.Fragment key={c.value}>
					<BreadcrumbItem
						icon={index === 0 ? <HomeIcon /> : undefined}
						value={c.value}
						label={c.label}
						onClick={c.onClick}
					/>
					{index !== crumbs.length - 1 && (
						<BreadcrumbSeparator separator={separator} />
					)}
				</React.Fragment>
			))}
		</div>
	)
}
